import React, { useState } from 'react';
import ProductPlaceholderArt from './ProductPlaceholderArt';

// Accept only the approved product hero selected by the caller. Swatches are
// displayed separately and must never become a product-photo fallback.
export default function CatalogProductImage({ src, alt, brand = '', className = '', fallbackTone, fallbackKind }) {
  const [failedSrc, setFailedSrc] = useState(null);
  if (!src || src === failedSrc) {
    return <ProductPlaceholderArt name={alt} brand={brand} tone={fallbackTone} kind={fallbackKind} />;
  }
  return <img src={src} alt={alt} className={className} loading="lazy" onError={() => setFailedSrc(src)} />;
}
